import { defineMessages } from "react-intl";

const messages = defineMessages({
  title: {
    id: "segmentHeader.title",
    description: "Origin to destination. Ex: London to Melbourne",
    defaultMessage: "{origin} to {destination}",
  },
  schedulesBtnLabel: {
    id: "label.scheduleDate",
    description: "The label above a travel date picker",
    defaultMessage: "Travel date",
  },
  departingNow: {
    id: "date.departingNow",
    description: 'Specifies that a departure date of "now" is selected',
    defaultMessage: "Departing now",
  },
  ticketsBtnLabel: {
    id: "label.ticketsBtn",
    description: "The text on a button that searches for tickets",
    defaultMessage: "Find tickets",
  },
  selectDatesCta: {
    id: "segmentHeader.selectDatesCta",
    defaultMessage: "Find Tickets",
    description:
      "Text on a button that opens the segment pane date picker on mobile",
  },
  singlePassengerCta: {
    id: "segmentHeader.passenger",
    defaultMessage: "{numPassengers} passenger",
    description:
      "Text on a button that opens the segment pane passenger picker on mobile, indicating a single passenger",
  },
  multiplePassengersCta: {
    id: "segmentHeader.passengers",
    defaultMessage: "{numPassengers} passengers",
    description:
      "Text on a button that opens the segment pane passenger picker on mobile, indicating multiple passengers",
  },
  fuelCostEstimate: {
    id: "segmentHeader.fuelCostEstimate",
    defaultMessage:
      "Cost estimate is for fuel (petrol/gas) only, based on recent prices. Does not include hire car, tolls or any other fees.",
    description:
      "Text when a tooltip is clicked to let know of the estimated fuel price",
  },
  titleOfFuelCost: {
    id: "segmentHeader.titleOfFuelCost",
    defaultMessage: "Fuel cost estimate",
    description: "Title to display the fuel cost estimate on mobile",
  },
  fuelIconTitle: {
    id: "segmentHeader.fuelIconTitle",
    defaultMessage: "Fuel",
    description:
      "Title to display the fuel cost estimate icon for accessibility",
  },
  ticketIconTitle: {
    id: "segmentHeader.ticketIconTitle",
    defaultMessage: "Ticket",
    description: "Title to display the ticket icon for accessibility",
  },
});

export default messages;
